// Generated by ReScript, PLEASE EDIT WITH CARE


var inital = {
  pickup: undefined,
  drop: undefined,
  name: undefined,
  mobile: undefined,
  requirement: undefined
};

export {
  inital ,
}
/* No side effect */
